import { REACT_APP_CAPTCHA_ENABLED, REACT_APP_CAPTCHA_SITE_KEY } from '../../config/settings/environment'

/**
 * Custom hook to get a recaptcha token.
 */
export const useRecaptcha = (action = 'buyer_search_engine') => {
  const executeRecaptcha = () =>
    new Promise(resolve => {
      if (REACT_APP_CAPTCHA_ENABLED !== 'true') {
        return resolve('')
      }

      return window.grecaptcha.enterprise.execute(REACT_APP_CAPTCHA_SITE_KEY, { action }).then(token => {
        resolve(token)
      })
    })

  return { executeRecaptcha }
}

/**
 * To initialize recaptcha.
 */
export const initializeRecaptcha = () => {
  if (REACT_APP_CAPTCHA_ENABLED !== 'true') {
    return
  }

  const script = document.createElement('script')
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${REACT_APP_CAPTCHA_SITE_KEY}`
  document.body.appendChild(script)
}
